import { gql } from '@apollo/client';

export default gql`
  mutation($email: String!) {
    forgotPasswordIssuerAdmin(email: $email)
  }
`;
